import { render } from "./KnowledgeChainPanel.vue?vue&type=template&id=ea876d2c"
import script from "./KnowledgeChainPanel.vue?vue&type=script&lang=js"
export * from "./KnowledgeChainPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__